export interface Testimonial {
  name: string;
  rating: number;
  text: string;
  source: string;
  shortText?: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Aaron Rousu",
    rating: 5,
    text: "What a great dealership. Ahmed went above and beyond to ensure we received the best value for our dollar. That evening, we received a call from Ahmed after hours as he knew we had a three hour drive home. He called to make sure we made it safely and told us to call him anytime. He even wrote a nice note for my son on the paperwork envelope. Absolutely outstanding service.",
    shortText: "Ahmed went above and beyond. Called after hours to make sure we made it home safely. Absolutely outstanding service.",
    source: "Google Review",
  },
  {
    name: "Stacey Bryant",
    rating: 5,
    text: "This is a very good and ethical dealership. Muhammad is the finance manager and he really does his best to work with every customer with nearly every financial situation. The vehicles are very high quality, solid, safe vehicles. Over the years I have avoided small dealerships, but that was not my experience here. Overall it was a really positive experience and I plan to return soon.",
    shortText: "Very good and ethical dealership. Muhammad works with every financial situation. High quality, solid vehicles. Plan to return.",
    source: "Google Review",
  },
  {
    name: "Julie Murray",
    rating: 5,
    text: "Ahmed and Chris were awesome!!! They were patient in answering all of our questions. They were very professional and friendly. We got a fantastic deal and are extremely pleased!!!",
    shortText: "Ahmed and Chris were professional, patient, and friendly. Got a fantastic deal. Extremely pleased!",
    source: "Google Review",
  },
  {
    name: "Jaymes Deree",
    rating: 5,
    text: "Super kind patient people, who are easy to work with, no questions left unanswered and very honest. They even have a 15 day warranty to back their purchase as being nice enough to say keep $20 for gas. Highly recommend.",
    shortText: "Super kind, patient people. No questions left unanswered. Honest. 15-day warranty included. Highly recommend.",
    source: "Google Review",
  },
  {
    name: "Candace Dale",
    rating: 5,
    text: "Terrific service. Ahmad was awesome! The whole experience was smooth and stress-free. I felt respected throughout the entire process and drove away in a great vehicle at a fair price.",
    shortText: "Terrific service. Ahmad was awesome! Smooth, stress-free experience. Drove away in a great vehicle at a fair price.",
    source: "Google Review",
  },
];
